// Cart productCodes the cart builder writes, kept in one place so the two
// sections that sell a hosting add-on (one riding a new plan in the cart, one
// for a plan the account already has) cannot spell the code two ways.

// hosting-addon-cyberpanel → HOSTING_ADDON_CYBERPANEL. squish-backend reads it
// back with checkout-pricing's skuFromProductCode (lowercase, _ → -), so this
// is that function's exact inverse.
export function addonProductCode(sku) {
  return String(sku).toUpperCase().replace(/-/g, '_');
}
